// 사업자등록증_지현창의주식회사_20260701.pdf 첫 페이지의 본점 정보.
export const BUSINESS_INFO = {
  name: '지현창의 주식회사',
  representative: '김지수',
  registrationNumber: '549-81-02953',
  address: '충청북도 청주시 흥덕구 풍산로178번길 42, 1층 101호(복대동)',
};
